// @/libs/analytics.ts
import { createVueBaiduAnalytics } from '@web-analytics/vue'

// The Create function returns an instance variable,
// And a method of installation for plugin
const {
    // Used in the entry file (e.g. `main.ts` ),
    // Will be registered as a Vue plugin and enabled
    registerBaiduAnalytics,
} = createVueBaiduAnalytics()

// Export them both
export { registerBaiduAnalytics }
